/**
 * Account settings: business-error model.
 *
 * The save surfaces one of two failures: a coarse infra failure
 * (`network` | `api`, from the app-wide `@/utils/infra-error`) or a business
 * `validation` failure carrying per-field messages. Only the update path can
 * fail against the backend (there is no async load: the identity is read from
 * `AuthContext`), so the mapper covers just that. Infra/unexpected errors are
 * not modelled here; they bubble to the generic handler.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

import type { ValidationErrors } from './account-draft.model';

export type AccountSettingsError =
  | InfraFailure
  | { kind: 'validation'; fields: ValidationErrors };

export function toAccountSettingsError(e: unknown): InfraFailure {
  return classifyInfraError(e, 'Failed to update account.');
}
